import React, { useEffect, useRef } from 'react'
import styles from './Work.module.scss'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Work = () => {

    const bg = useRef(null)

    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger)
        gsap.fromTo(bg.current, {
            backgroundColor: '#fff'
        }, {
            scrollTrigger: {
                trigger: bg.current,
                scrub: true,
                start: 'bottom bottom',
                // end: 'bottom bottom',
                onLeave: () => gsap.to(bg.current, { backgroundColor: '#000', zIndex: 1, duration: 1, height: '100vh' }),
                onLeaveBack: () => gsap.fromTo(bg.current, { backgroundColor: '#000', yPercent: 100, zIndex: 1, duration: 1, height: '100vh' }),
                onEnterBack: () => gsap.to(bg.current, { backgroundColor: '#fff', zIndex: 1, duration: 1, height: '100vh' }),
            },
        })

    }, [])


    return (
        <div className={styles.work}>
            <div className={styles.textContainer}>
                <h1>Work <br /> That Rocks!</h1>
            </div>
            <div ref={bg} className={styles.bgContainer}></div>
        </div>
    )
}

export default Work